<template>
    <img src="../assets/img/icons/mapmarker.png" style="">
</template>

<script>

export default {
  name: 'MapPin',
  data() {
      return {
          
      }
  }
}
</script>
<style scoped>
img {
  position: absolute;
  width: 46px;
}
@media(max-width: 600px) {
    img {
        width: 25px;
    }
}

@-webkit-keyframes pulse {
 0% {
 -webkit-transform: scale(1, 1);
}
 50% {
 -webkit-transform: scale(1.1, 1.1);
}
 100% {
 -webkit-transform: scale(1, 1);
};
}

@keyframes pulse {
 0% {
 transform: scale(1, 1);
}
 50% {
 transform: scale(1.1, 1.1);
}
 100% {
transform: scale(1, 1);
};
}

img.fact-0,img.fact-1,img.fact-2,img.fact-3,img.fact-4 {
	-webkit-animation: pulse 1.5s linear infinite;
	animation: pulse 1.5s linear infinite;
}
</style>